import React, { Component } from "react";
import {
  egeeTouchPlans,
  planToNumber,
  deploymentEnvironment,
  customLog,
} from "../../variables/Variables";
import { fire } from "../../firebase/index"; // <-- NEW
import ContactCustomPlan from "../ContactUs/ContactUsCustomPlan";
import ReactGA from "react-ga";
import "../../assets/css/maincss.css";
import "../../assets/css/packagepricing.css";
import Switch from "react-switch";
import ipapi from "ipapi.co";
import LocalizedStrings from "react-localization";

/* ===================== i18n (yours, unchanged) ===================== */
let localizationStrings = new LocalizedStrings({
  en: {
    starterPackage: egeeTouchPlans.egeeTouchplan1.planName,
    essentialPackage: egeeTouchPlans.egeeTouchplan2.planName,
    proPackage: egeeTouchPlans.egeeTouchplan3.planName,
    starterPlusPackage: egeeTouchPlans.egeeTouchplan5.planName,
    essentialPlusPackage: egeeTouchPlans.egeeTouchplan6.planName,

    starterPlanPrice: "$19.90/month",
    essentialPlanPrice: "$39.90/month",
    proPlanPrice: "$99.90/month",
    starterPlusPlanPrice: "$29.90/month",
    essentialPlusPlanPrice: "$59.90/month",

    starterPlanPriceDiscount:
      egeeTouchPlans.egeeTouchplan1.planPrice + "/month",
    essentialPlanPriceDiscount:
      egeeTouchPlans.egeeTouchplan2.planPrice + "/month",
    proPlanPriceDiscount: egeeTouchPlans.egeeTouchplan3.planPrice + "/month",
    starterPlusPlanPriceDiscount:
      egeeTouchPlans.egeeTouchplan5.planPrice + "/month",
    essentialPlusPlanPriceDiscount:
      egeeTouchPlans.egeeTouchplan6.planPrice + "/month",

    starterPlanPriceAnnual: "$238.80/year",
    essentialPlanPriceAnnual: "$478.80/year",
    proPlanPriceAnnual: "$1198.80/year",
    starterPlusPlanPriceAnnual: "$358.80/year",
    essentialPlusPlanPriceAnnual: "$718.80/year",

    starterPlanPriceAnnualDiscount:
      egeeTouchPlans.egeeTouchplan1.planPriceAnnual + "/year",
    essentialPlanPriceAnnualDiscount:
      egeeTouchPlans.egeeTouchplan2.planPriceAnnual + "/year",
    proPlanPriceAnnualDiscount:
      egeeTouchPlans.egeeTouchplan3.planPriceAnnual + "/year",
    starterPlusPlanPriceAnnualDiscount:
      egeeTouchPlans.egeeTouchplan5.planPriceAnnual + "/year",
    essentialPlusPlanPriceAnnualDiscount:
      egeeTouchPlans.egeeTouchplan6.planPriceAnnual + "/year",

    packageHeader: "Subscription Package",
    subscriptionTitle: "Try for free",
    trialTitle: "14 days FREE trial period",
    padlockTitle: "Smart Padlocks*",
    userAccountsTitle: "User Accounts",
    maxMultiApproval: "Layer of Multi Approval",
    monthlyTitle: "Monthly",
    annualTitle: "Annual",
    saveAmtTitle: "Save 12% extra!",
    warningTitles1: "Require Custom Plan?",
    warningTitles2: "Please contact sales at info@egeetouch.com",
    redemptionCodeTitle: "Use your Product Key here",
    uptoTitle: "Up to",
    warningTitles3:
      "*Subscription Package for Intelligent Access Management (IAM) System does not include eGeeTouch Smart Padlocks. eGeeTouch Smart Padlocks are SOLD SEPARATELY",
    noCardMessage: "No card required",
    subMessage_1: "Start ",
    subMessage_2: "free",
    subMessage_3: ".",
    subMessage_4: " No credit card required.",
    pricingTitle: "eGeeTouch IAM Subscription Plans",
    pricingSubtitle: "Choose A Subscription Plan for Your Application",

    ctaTryFree: "Try for FREE",
    ctaSubscribeNow: "Subscribe Now",
    ctaSubscribeYearly: "Subscribe Yearly",

    groupEntry: "Entry",
    groupMoreLockLessUser: "More Lock - Less User",
    groupMoreUserLessLock: "More User - Less Lock",
    groupLargeApplication: "Large Application",

    labelLock: "LOCK",
    labelAppUsers: "App Users",
    labelNfcFobUsers: "NFC Fob Users",
    labelMultiApproval: "Multi Approval",
    labelRemarks: "Remarks",
    labelTotalUsers: "TOTAL USERS",

    lowAsPrefix: "as LOW as",
    lowAsPerUserPer: "per User per",

    unitMonth: "Month",
    unitYear: "Year",

    remarkFree:
      "Mobile App Only <br> Free 14 days trial for IAM Web System <br> (No Credit Card Needed)",
    remarkStarter:
      "Entry Level and Pilot Testing.<br> Each lock can be accessed Up to 8 users",
    remarkEachLockUpTo: "Each lock can be accessed Up to {n} users",
  },
  ja: {
    pricingTitle: "eGeeTouch IAM サブスクリプションプラン",
    pricingSubtitle:
      "ご利用用途に合ったサブスクリプションプランをお選びください",
    monthlyTitle: "月額",
    annualTitle: "年額",
    saveAmtTitle: "さらに12%お得！",

    warningTitles1:
      "掲載のプラン以外をご希望の場合(カスタムプラン)もしくは、API連携については、",
    warningTitles2: "info@egeetouch.comへ詳細についてお問合せ下さい",
    warningTitles3:
      "*IAMのサブスクリプションには eGeeTouch スマート南京錠は含まれません。南京錠は別売りです。",
    redemptionCodeTitle: "プロダクトコード入力はこちらから",

    // (keep your existing ja keys below)

    planHeaders: [
      "無料プラン",
      "スタータープラン",
      "LFプラン",
      "Pro-LFプラン",
      "UFプラン",
      "Pro-UFプラン",
      "LAプラン",
    ],
    ctaTryFree: "無料で試す",
    ctaSubscribeNow: "今すぐ申し込む",
    ctaSubscribeYearly: "年額で申し込む",

    labelLock: "スマートロック台数",
    labelAppUsers: "アプリ登録メンバー数",
    labelNfcFobUsers: "NFC登録数",
    labelMultiApproval: "承認者数",
    labelRemarks: "備考",
    labelTotalUsers: "ご利用可能メンバー数",

    lowAsPrefix: "1ユーザーあたり最安",
    lowAsPerUserPer: "",

    unitMonth: "月",
    unitYear: "年",

    remarkFree: "個人利用（無料）",
    remarkStarter: "アプリ登録数最大4、1台のロックに登録できるNFC数最大4",
    remarkEachLockUpTo:
      "アプリ登録数最大{m}、1台のロックに登録できるNFC数最大{o}",
  },
});

/* ===================== GA tracker (yours) ===================== */
var trackerID = "";
if (deploymentEnvironment) {
  trackerID = "G-7D4M74VB11";
} else {
  trackerID = "G-LWK1V2E1FE";
}

/* ===================== Firebase → table feeds helpers ===================== */
const PLAN_ORDER = [
  "free",
  "starter",
  "lock_focus",
  "pro_locks",
  "user_focus",
  "pro_users",
  "large_application",
];

const COLOR_CLASSES = [
  "entry-free",
  "entry-starter",
  "lock-focus",
  "pro-locks",
  "user-focus",
  "pro-users",
  "large-app",
];

function moneyFmt(val, currency = "USD") {
  const n = typeof val === "string" ? parseFloat(val) : Number(val ?? 0);
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(isFinite(n) ? n : 0);
  } catch {
    return `$${(isFinite(n) ? n : 0).toFixed(2)}`;
  }
}
const toNum = (v, fb = 0) => {
  const n = typeof v === "string" ? parseFloat(v) : Number(v ?? fb);
  return isFinite(n) ? n : fb;
};

function formatTemplate(str, vars) {
  return String(str || "").replace(/\{(\w+)\}/g, (_, k) => vars?.[k] ?? "");
}

function buildDataFeedsFromFirebase(payload, t) {
  const plans = PLAN_ORDER.map((k) => payload?.[k] ?? {});

  const headers = t.planHeaders || [
    "Free",
    "Starter",
    "Lock Focus",
    "Pro Locks",
    "User Focus",
    "Pro Users",
    "Large App",
  ];

  // pricing rows
  const monthly = plans.map((p) =>
    moneyFmt(p.price_month, p.currency || "USD")
  );
  const perUser = plans.map((p, i) =>
    i === 0
      ? ""
      : p.price_user_month != null
      ? moneyFmt(p.price_user_month, p.currency || "USD")
      : ""
  );

  const ctas = [
    t.ctaTryFree || "Try for FREE",
    t.ctaSubscribeNow || "Subscribe Now",
    t.ctaSubscribeNow || "Subscribe Now",
    t.ctaSubscribeNow || "Subscribe Now",
    t.ctaSubscribeNow || "Subscribe Now",
    t.ctaSubscribeNow || "Subscribe Now",
    t.ctaSubscribeNow || "Subscribe Now",
  ];

  const pricing = [monthly, perUser, ctas];

  // features
  const locks = plans.map((p, i) => (i === 0 ? 2 : toNum(p.max_locks)));
  const appUsers = plans.map((p, i) => (i === 0 ? 2 : toNum(p.max_app_users)));
  const nfcUsers = plans.map((p, i) =>
    i === 0 ? 2 : toNum(p.max_nfc_tags_users)
  );
  const approvals = plans.map((p, i) =>
    i === 0 ? 0 : toNum(p.max_multi_approval)
  );

  const remarks = plans.map((p, i) => {
    if (i === 0)
      return (
        t.remarkFree ||
        "Mobile App Only <br> Free 14 days trial for IAM Web System <br> (No Credit Card Needed)"
      );
    if (i === 1)
      return (
        t.remarkStarter ||
        "Entry Level and Pilot Testing.<br> Each lock can be accessed Up to 8 users"
      );

    const fixedLimits = { 2: 20, 3: 100, 4: 70, 5: 280, 6: 1000 };
    const n =
      fixedLimits[i] ||
      toNum(p.max_users, 0) ||
      Math.max(toNum(p.max_app_users, 0), toNum(p.max_nfc_tags_users, 0)) ||
      10;

    // ✅ NEW: values for JP template
    const m =
      toNum(p.max_app_users, 0) ||
      (fixedLimits[i] ? Math.min(fixedLimits[i], 9999) : 0); // optional fallback
    const o = toNum(p.max_nfc_tags_users, 0);

    // ✅ Pass all vars. EN uses {n}. JP uses {m} and {o}.
    return formatTemplate(
      t.remarkEachLockUpTo || "Each lock can be accessed Up to {n} users",
      { n, m, o }
    );
  });

  const manageAndAdd = [
    { label: t.labelLock || "LOCK", values: locks },
    { label: t.labelAppUsers || "App Users", values: appUsers },
    { label: t.labelNfcFobUsers || "NFC Fob Users", values: nfcUsers },
    { label: t.labelMultiApproval || "Multi Approval", values: approvals },
    { label: t.labelRemarks || "Remarks", values: remarks },
  ];

  const colorClasses = COLOR_CLASSES;

  const columnGroups = [
    {
      title: t.groupEntry || "Entry",
      span: 2,
      className: "head-chip chip-entry",
    },
    {
      title: t.groupMoreLockLessUser || "More Lock - Less User",
      span: 2,
      className: "head-chip chip-lock",
    },
    {
      title: t.groupMoreUserLessLock || "More User - Less Lock",
      span: 2,
      className: "head-chip chip-user",
    },
    {
      title: t.groupLargeApplication || "Large Application",
      span: 1,
      className: "head-chip chip-large",
    },
  ];

  return { headers, pricing, manageAndAdd, colorClasses, columnGroups };
}

/* ===================== Component ===================== */
class SubscriptionPackageNew extends Component {
  constructor(props) {
    super(props);
    this.state = {
      countryCode: "",
      currentLanguage: "en",
      annualPayment: false,
      feeds: null, // <-- NEW: holds built arrays
      loadingFeeds: true, // <-- NEW
      feedsError: null, // <-- NEW
    };

    this.handleSubscriptionButtonClick = this.handleSubscriptionButtonClick.bind(
      this
    );
    this.handleRedemptionButtonClick = this.handleRedemptionButtonClick.bind(
      this
    );
    this.toggleBilling = this.toggleBilling.bind(this);
  }

  componentDidMount() {
    // Geo (yours)
    ipapi.location((callback) => {
      if (!callback) return;

      const cc = callback.country_code;
      const lang = cc === "JP" ? "ja" : "en"; // ✅ GB should be EN

      customLog("country code " + cc);

      localizationStrings.setLanguage(lang); // ✅ set language NOW (not in render)

      this.setState({ countryCode: cc, currentLanguage: lang }, () => {
        // ✅ load firebase AFTER language is decided
        const ref = fire
          .database()
          .ref("/mobileSubscriptionPlans2025/default-US");
        ref
          .once("value")
          .then((snap) => {
            const built = buildDataFeedsFromFirebase(
              snap.val() || {},
              localizationStrings
            );
            this.setState({ feeds: built, loadingFeeds: false });
          })
          .catch((e) => {
            this.setState({
              feedsError: e?.message || "Failed to load pricing",
              loadingFeeds: false,
            });
          });
      });
    });
  }

  // optional: switch to live updates instead of once():
  // componentWillUnmount() { ref.off(); }

  handleSubscriptionButtonClick(planName) {
    window.location.href = `/signup${
      planName ? `?plan=${encodeURIComponent(planName)}` : ""
    }`;
    sessionStorage.planButtonClicked = "subscription";
  }

  handleRedemptionButtonClick() {
    ReactGA.event(
      { category: "redemption", action: "enter redemption page", value: 1 },
      [trackerID]
    );
    window.location.href = "/signup";
    sessionStorage.planButtonClicked = "redemption";
  }

  toggleBilling(checked) {
    this.setState({ annualPayment: checked });
  }

  render() {
    const { annualPayment, feeds, loadingFeeds, feedsError } = this.state;
    const YEARLY_DISCOUNT = 0.12;

    if (loadingFeeds)
      return <div className="container-iam mx-auto">Loading pricing…</div>;
    if (feedsError)
      return (
        <div className="container-iam mx-auto" style={{ color: "red" }}>
          Error: {feedsError}
        </div>
      );
    if (!feeds) return null;

    // ---- DATA FEEDS now come from Firebase ----
    const {
      headers,
      pricing,
      manageAndAdd,
      colorClasses,
      columnGroups,
    } = feeds;

    const priceColorClass = (i) => {
      const map = [
        "price-blue",
        "price-red",
        "price-green",
        "price-purple",
        "price-pink",
        "price-gray",
        "price-dark",
      ];
      return map[i] || "price-gray";
    };

    const parseMoney = (str) =>
      Number(String(str).replace(/[^0-9.]/g, "")) || 0;
    const fmt = (n) =>
      n.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

    const priceCells = pricing[0].map((p, i) => {
      const monthly = parseMoney(p);
      const annualOriginal = monthly * 12;
      const value = annualPayment
        ? annualOriginal * (1 - YEARLY_DISCOUNT)
        : monthly;
      const unit = annualPayment
        ? ` / ${localizationStrings.unitYear}`
        : ` / ${localizationStrings.unitMonth}`;

      const showCompare =
        annualPayment && i !== 0 && annualOriginal > 0 && YEARLY_DISCOUNT > 0;
      return {
        value: fmt(value),
        unit,
        color: priceColorClass(i),
        annualOriginal: fmt(annualOriginal),
        showCompare,
      };
    });

    const lowAsCells = pricing[1].map((p) => {
      if (!p) return "";
      const monthly = parseMoney(p);
      const value = annualPayment
        ? monthly * 12 * (1 - YEARLY_DISCOUNT)
        : monthly;
      const unitWord = annualPayment
        ? localizationStrings.unitYear
        : localizationStrings.unitMonth;

      return { text: `$${fmt(value)}`, unitWord };
    });

    const appUsers = manageAndAdd[1]?.values || [];
    const nfcUsers = manageAndAdd[2]?.values || [];

    const totalUsers = appUsers.map((v, i) => (v || 0) + (nfcUsers[i] || 0));

    // ===================== UI (your table, unchanged) =====================
    return (
      <section className="m-top-10">
        <div className="container-iam mx-auto">
          <h1 className="text-center btitle">
            {localizationStrings.pricingTitle}
          </h1>
          <h4 className="text-center mb-4">
            {localizationStrings.pricingSubtitle}
          </h4>

          <div
            className="switchBtnWrapper"
            style={{ position: "relative", top: "20", margin: "10px 0 20px" }}
          >
            <section
              style={{
                marginLeft: "auto",
                marginRight: "auto",
                width: "80%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <span className="annualMonthlyTitles">
                {localizationStrings.monthlyTitle}
              </span>
              <Switch
                className="annualMonthlyBtn"
                onChange={this.toggleBilling}
                checked={annualPayment}
                offColor="#cbd5e1"
                onColor="#0d8cbf"
                uncheckedIcon={false}
                checkedIcon={false}
                height={20}
                width={44}
                handleDiameter={18}
              />
              <span className="annualMonthlyTitles">
                {localizationStrings.annualTitle}
              </span>
              <div className="saveMoreAlert">
                {localizationStrings.saveAmtTitle}
              </div>
            </section>
          </div>

          <div className="table-responsive newplanstable">
            <table className="table table-bordered align-middle">
              <thead>
                <tr>
                  <th rowSpan={5} className="th-iam"></th>
                  {columnGroups.map((g, idx) => (
                    <th key={idx} colSpan={g.span} className={g.className}>
                      {g.title}
                    </th>
                  ))}
                </tr>

                <tr>
                  {headers.map((head, i) => (
                    <th key={i} className="border-y-none">
                      {head}
                    </th>
                  ))}
                </tr>

                <tr>
                  {priceCells.map((pc, i) => (
                    <th key={`price-${i}`} className="border-y-none">
                      {pc.showCompare && (
                        <div className="price-compare">
                          <span className="price-old">
                            <sup>$</sup>
                            {pc.annualOriginal}
                          </span>
                          <span className="price-off">
                            (-{Math.round(YEARLY_DISCOUNT * 100)}%)
                          </span>
                        </div>
                      )}
                      <span className={`plan-price ${pc.color}`}>
                        <sup>$</sup>
                        {pc.value}
                        <sub>
                          <small>{pc.unit}</small>
                        </sub>
                      </span>
                    </th>
                  ))}
                </tr>

                {this.state.currentLanguage !== "ja" && (
                  <tr>
                    {lowAsCells.map((lc, i) => (
                      <td key={`low-${i}`} className="border-y-none">
                        {i === 0 || !lc ? (
                          ""
                        ) : (
                          <>
                            as LOW as <br />
                            <span className="text-bold">{lc.text}</span>
                            <br />
                            per User per {lc.unitWord}
                          </>
                        )}
                      </td>
                    ))}
                  </tr>
                )}

                <tr>
                  {pricing[2].map((label, i) => (
                    <td key={`cta-${i}`} className="border-y-none">
                      <button
                        className={`pricing-btn ${colorClasses[i]}`}
                        onClick={() =>
                          this.handleSubscriptionButtonClick(PLAN_ORDER[i])
                        }
                      >
                        {annualPayment &&
                        label.toLowerCase().includes("subscribe")
                          ? localizationStrings.ctaSubscribeYearly
                          : label}
                      </button>
                    </td>
                  ))}
                </tr>
              </thead>

              <tbody>
                {manageAndAdd.map((row, rIdx) => {
                  const isNfc = rIdx === 2;
                  const isRemarks = rIdx === 4;

                  return (
                    <React.Fragment key={`feat-${rIdx}`}>
                      <tr className={isRemarks ? "remarks-row" : ""}>
                        <th
                          className={`th-iam ${
                            rIdx === 1 || rIdx === 2 ? "pad-start" : ""
                          }`}
                        >
                          {row.label}
                        </th>

                        {row.values.map((val, cIdx) => (
                          <td key={`feat-${rIdx}-${cIdx}`}>
                            {isRemarks ? (
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: String(val ?? ""),
                                }}
                              />
                            ) : (
                              val
                            )}
                          </td>
                        ))}
                      </tr>

                      {isNfc && (
                        <tr className="total-users-row">
                          <th className="th-iam">
                            {localizationStrings.labelTotalUsers}
                          </th>
                          {totalUsers.map((val, i) => (
                            <td key={`tot-${i}`}>
                              <strong>{val}</strong>
                            </td>
                          ))}
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
          </div>

          <div className="warningMessage">
            <ContactCustomPlan />
            {localizationStrings.warningTitles2}
            <p className="warningMessage2">
              {localizationStrings.warningTitles3}
            </p>
          </div>

          <div
            style={{
              width: "90%",
              marginLeft: "auto",
              marginRight: "auto",
              textAlign: "center",
              paddingBottom: "20px",
            }}
          >
            <button
              style={{
                borderRadius: "50px",
                border: "none",
                backgroundColor: "orange",
                padding: "10px",
                fontWeight: "700",
                color: "white",
                marginLeft: "auto",
                marginRight: "auto",
                fontSize: "20px",
              }}
              onClick={this.handleRedemptionButtonClick}
            >
              {localizationStrings.redemptionCodeTitle}
            </button>
          </div>
        </div>
      </section>
    );
  }
}

export default SubscriptionPackageNew;
